var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440 32H296C291.578 32 288 35.578 288 40S291.578 48 296 48H420.688L294.525 174.164C263.232 145.578 221.721 128 176 128C78.799 128 0 206.797 0 304S78.799 480 176 480C273.203 480 352 401.203 352 304C352 258.281 334.42 216.766 305.838 185.477L432 59.312V184C432 188.422 435.578 192 440 192S448 188.422 448 184V40C448 35.578 444.422 32 440 32ZM176 464C87.775 464 16 392.223 16 304S87.775 144 176 144S336 215.777 336 304S264.225 464 176 464Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMars);
export default __webpack_public_path__ + "static/media/mars.aabbc8c670474e3a5e32de3774e2beb7.svg";
export { ForwardRef as ReactComponent };